<template>
  <div class="qrcode"></div>
</template>
<script>
  var timer;
  import member from '../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { Button,Toast } from 'vant';
  export default {
    data () {
      return {

      }
    },
    created () {
      location.href='weixin://dl/business/?appid=wxa61525f4417f6fbd&path=pages/start/start&query=register_channel=anxin'
    },
    methods: {

    },
    components: {
      [Button.name]:Button,
      [Toast.name]:Toast
    }
  }
</script>
<style lang="scss">
  .qrcode{

  }
</style>
